import React from 'react';

import Framework from "@beardeddevops/react.framework";
import ScheduleApprovalsComponent from "components/Collections/ScheduleApprovals"

export default class ScheduleApprovals extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history,initialDate} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar history={history}/>

				<ScheduleApprovalsComponent history={history} id={this.props.user} isFe={true} initialDate={initialDate}/>

			</div>
		)
	}
}